import React from "react";
import { Logo } from "./logo";
import { SUPPORT_EMAIL_LINK } from "@constants";
import { Box, Link, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";

export const Footer: React.FC = () => {
  const location = useLocation();

  return location.pathname !== "/login" ? (
    <Box
      component="footer"
      role="contentinfo"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py={2}
      borderTop={1}
      borderColor="grey.300"
    >
      {location.pathname === "/" ? (
        <Typography variant="body2" color="textPrimary">
          <span>If you need assistance please contact us at </span>
          <Link
            href={SUPPORT_EMAIL_LINK}
            target="_blank"
            color="primary"
            rel="noopener noreferrer"
          >
            gears_help@globalpay.com
          </Link>
          
        </Typography>
      ) : null}
      <Logo />
    </Box>
  ) : null;
};
